export default "__VITE_ASSET__a5220ed3__"